import React from 'react';
import { SitemapNode } from '../../../extViewmodels/sdk/models/Website';
import { BreadcrumbBar } from '../../components-v2/BreadcrumbBar';

interface Props {
	sitemap?: SitemapNode[];
	/** Root-relative path of the page in the preview, e.g. `/services/roofing`. */
	pagePath: string;
}

/**
 * The AppBar's breadcrumb slot. NavigationBreadcrumbsBar builds its crumbs from the pathname, and the open page
 * lives in the query string, so the crumbs are assembled here instead.
 */
export function WebsiteBreadcrumbs({ sitemap, pagePath }: Props) {
	const pageName = sitemap?.find(node => node.resolvedUrl === pagePath)?.pageName;
	return <BreadcrumbBar items={[{ label: 'Website', path: '/website' }, ...(pageName ? [{ label: pageName }] : [])]} />;
}
